import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography } from '@mui/material';

const s:any = {
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 2,
  },
  picker: {
    p: 2,
    border: '1px dashed #c9d5ea',
    borderRadius: 2,
    backgroundColor: '#f8fbff',
  },
  previewWrap: {
    p: 1.5,
    borderRadius: 2,
    border: '1px solid #e5ecf7',
    maxWidth: 360,
  },
  preview: {
    width: '100%',
    borderRadius: 8,
    objectFit: 'cover',
    maxHeight: 260,
  },
  helper: {
    color: '#6b7280',
    fontSize: 13,
  },
};

class PhotoPanel extends Component<any, any> {
  static propTypes: any;
  static defaultProps: any;

  constructor(props: any) {
    super(props);
    this.state = {
      previewUrl: '',
    };
  }

  componentDidMount() {
    const photo = this.props?.data?.photo;
    this.setState({ previewUrl: photo?.previewUrl || '' });
    this.syncValidity(photo);
  }

  componentWillUnmount() {
    const { previewUrl } = this.state;
    if (previewUrl && previewUrl.startsWith('blob:')) {
      URL.revokeObjectURL(previewUrl);
    }
  }

  syncValidity = (photo: any) => {
    // Photo step is optional.
    if (typeof this.props.setValid === 'function') this.props.setValid(true);
  };

  setPhoto = (photo: any) => {
    this.props.setItem('data', 'photo', photo);
    const newdata = { ...(this.props?.data?.data || {}), img: photo?.previewUrl || '' };
    this.props.setItem('data', 'data', newdata);
    this.syncValidity(photo);
  };

  onFileChange = (event: any) => {
    const file = event?.target?.files?.[0];
    if (!file) return;

    const oldPreview = this.state.previewUrl;
    if (oldPreview && oldPreview.startsWith('blob:')) {
      URL.revokeObjectURL(oldPreview);
    }

    const previewUrl = URL.createObjectURL(file);
    const photo = {
      file,
      name: file.name,
      size: file.size,
      type: file.type,
      previewUrl,
    };

    this.setState({ previewUrl });
    this.setPhoto(photo);
  };

  onClear = () => {
    const { previewUrl } = this.state;
    if (previewUrl && previewUrl.startsWith('blob:')) {
      URL.revokeObjectURL(previewUrl);
    }
    this.setState({ previewUrl: '' });
    this.setPhoto(null);
  };

  render() {
    const { previewUrl } = this.state;
    const photo = this.props?.data?.photo;
    return (
      <Box sx={{ ...s.root }}>
        <Box sx={{ ...s.picker }}>
          <Typography variant="subtitle1">Profile Photo</Typography>
          <Typography sx={{ ...s.helper, mt: 0.5 }}>
            Upload a clear portrait image (JPG/PNG/JPEG, max 10MB).
          </Typography>
          <Box sx={{ mt: 2, display: 'flex', gap: 1.5, alignItems: 'center', flexWrap: 'wrap' }}>
            <Button variant="contained" component="label">
              Choose Photo
              <input
                hidden
                accept="image/*"
                type="file"
                onChange={this.onFileChange}
              />
            </Button>
            <Button variant="outlined" color="inherit" onClick={this.onClear} disabled={!photo?.file}>
              Remove
            </Button>
            <Typography sx={{ ...s.helper }}>
              {photo?.name || 'No file selected'}
            </Typography>
          </Box>
        </Box>
        {previewUrl && (
          <Box sx={{ ...s.previewWrap }}>
            <img src={previewUrl} alt="Member profile preview" style={s.preview} />
          </Box>
        )}
      </Box>
    );
  }
}

PhotoPanel.propTypes = {
  classes: PropTypes.object,
};

export default PhotoPanel;
